export const createError = (message, response) => {
    const { config, request } = response;
    const error = new Error(message);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.config = config;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.request = request;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.response = response;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.isAxiosError = true;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error._isAxiosError = true;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};
